 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","BigEvent":"BigEvent","BigEventAdd":"BigEventAdd","BrandDictionary":"BrandDictionary","BrandDictionaryAdd":"BrandDictionaryAdd","DictionaryDigitalAdd":"DictionaryDigitalAdd","DictionaryMagazine":"DictionaryMagazine","DictionaryMagazineAdd":"DictionaryMagazineAdd","DictionaryManageAdd":"DictionaryManageAdd","DictionaryResearch":"DictionaryResearch","DictionaryResearchAdd":"DictionaryResearchAdd","DictionaryTrain":"DictionaryTrain","DictionaryTrainAdd~SocietyActivityAdd":"DictionaryTrainAdd~SocietyActivityAdd","DictionaryTrainAdd":"DictionaryTrainAdd","SocietyActivityAdd":"SocietyActivityAdd","Email":"Email","Home":"Home","Login":"Login","SocietyActivity":"SocietyActivity","TrainCourseApply":"TrainCourseApply","TrainCourseApplyEdit":"TrainCourseApplyEdit"}[chunkId]||chunkId) + "." + {"404":"8bf2f0f0","BigEvent":"9cdb7798","BigEventAdd":"9366c25a","BrandDictionary":"8d32c528","BrandDictionaryAdd":"dfed3b3a","DictionaryDigitalAdd":"06429b49","DictionaryMagazine":"000303a0","DictionaryMagazineAdd":"eca2df23","DictionaryManageAdd":"e5d72698","DictionaryResearch":"665bd191","DictionaryResearchAdd":"a452537c","DictionaryTrain":"8939184a","DictionaryTrainAdd~SocietyActivityAdd":"8f3d04cd","DictionaryTrainAdd":"268669fe","SocietyActivityAdd":"f3063f8b","Email":"8c9fc419","Home":"414b7a5b","Login":"92be26ad","SocietyActivity":"f761d6e8","TrainCourseApply":"e21979d6","TrainCourseApplyEdit":"34feb15b","chunk-4d8f13fd":"5910fe74","chunk-4ec82ea2":"80bca8f1","chunk-dab50a2c":"df6cd1bc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"BigEvent":1,"BigEventAdd":1,"BrandDictionary":1,"BrandDictionaryAdd":1,"DictionaryDigitalAdd":1,"DictionaryMagazine":1,"DictionaryMagazineAdd":1,"DictionaryManageAdd":1,"DictionaryResearch":1,"DictionaryResearchAdd":1,"DictionaryTrain":1,"DictionaryTrainAdd~SocietyActivityAdd":1,"DictionaryTrainAdd":1,"SocietyActivityAdd":1,"Email":1,"Home":1,"Login":1,"SocietyActivity":1,"TrainCourseApply":1,"TrainCourseApplyEdit":1,"chunk-4d8f13fd":1,"chunk-4ec82ea2":1,"chunk-dab50a2c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","BigEvent":"BigEvent","BigEventAdd":"BigEventAdd","BrandDictionary":"BrandDictionary","BrandDictionaryAdd":"BrandDictionaryAdd","DictionaryDigitalAdd":"DictionaryDigitalAdd","DictionaryMagazine":"DictionaryMagazine","DictionaryMagazineAdd":"DictionaryMagazineAdd","DictionaryManageAdd":"DictionaryManageAdd","DictionaryResearch":"DictionaryResearch","DictionaryResearchAdd":"DictionaryResearchAdd","DictionaryTrain":"DictionaryTrain","DictionaryTrainAdd~SocietyActivityAdd":"DictionaryTrainAdd~SocietyActivityAdd","DictionaryTrainAdd":"DictionaryTrainAdd","SocietyActivityAdd":"SocietyActivityAdd","Email":"Email","Home":"Home","Login":"Login","SocietyActivity":"SocietyActivity","TrainCourseApply":"TrainCourseApply","TrainCourseApplyEdit":"TrainCourseApplyEdit"}[chunkId]||chunkId) + "." + {"404":"e16936e7","BigEvent":"5b1dce95","BigEventAdd":"ca875a84","BrandDictionary":"8d6835cd","BrandDictionaryAdd":"685f6b9a","DictionaryDigitalAdd":"84b74465","DictionaryMagazine":"8acdc98f","DictionaryMagazineAdd":"fa79e316","DictionaryManageAdd":"d6068b51","DictionaryResearch":"cc854d43","DictionaryResearchAdd":"2dd4bb47","DictionaryTrain":"def97c2a","DictionaryTrainAdd~SocietyActivityAdd":"327cb498","DictionaryTrainAdd":"08c653db","SocietyActivityAdd":"fbf6115c","Email":"6efb1aee","Home":"d8d68d22","Login":"10784f3f","SocietyActivity":"94147592","TrainCourseApply":"3f40fdc4","TrainCourseApplyEdit":"2d0d3776","chunk-4d8f13fd":"e41d8c48","chunk-4ec82ea2":"549e683e","chunk-dab50a2c":"2327b4e8"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
